import { Component, Injectable, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'delete-person-modal',
  templateUrl: 'delete-person-modal.component.html',
  styleUrls: ['delete-person-modal.component.scss'],
  standalone: false
})
export class DeletePersonModalComponent {
  textMatcherValue: string = '';

  constructor(
    public dialogRef: MatDialogRef<DeletePersonModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  isDeleteButtonDisabled() {
    return this.textMatcherValue != 'DELETE';
  }

  archiveButtonClicked() {
    return { archive: true, delete: false };
  }

  deleteButtonClicked() {
    return { archive: false, delete: true };
  }

  cancelButtonClicked() {
    return { archive: false, delete: false };
  }
}
